import {
  addCampaignApi,
  getSequencesARI,
  updateCampaignApi,
  fetchCandidateJobMax as fetchCandidateJobMaxApi,
} from 'util/Api/campaign';
import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import {
  searchCampaigns,
  getScheduledMessages,
  getCampaignCandidates,
  getCampaignBGEvent,
  getCampaign,
  addCandidateToCampaign as addCandidateToCampaignApi,
  addNewCampaign as addNewCampaignApi,
  removeMultipleSelectedApi,
  addATSCandidateToCampaignApi,
  addBulkCandidateToCampaign as addBulkCandidateToCampaignApi,
} from 'util/Api/user';
export const setCandidateAddedToCampaign = createAction('user/setCandidateAddedToCampaign');
export const setCampaignAdded = createAction('campaigns/setCampaignAdded');
export const setCampaignUpdated = createAction('campaigns/setCampaignUpdated');
export const resetCampaign = createAction('campaigns/resetCampaign');
export const resetCampaignJobData = createAction('campaigns/resetCampaignJobData');
export const setCampaignJobData = createAction('campaigns/setCampaignJobData');
export const enableDlcForm = createAction('campaigns/enableDlcForm');
export const resetCampaignOptions = createAction('campaigns/resetCampaignOptions');

const searchCampaignsApi = async (
  { value, itemsPerPage, sort, filter, page, isAutoSuggest },
  { rejectWithValue },
) => {
  try {
    return await searchCampaigns({
      value,
      itemsPerPage,
      sort,
      filter,
      page,
      isAutoSuggest,
    });
  } catch (err) {
    return rejectWithValue(err);
  }
};

export const fetchCampaigns = createAsyncThunk('campaigns/fetchCampaigns', searchCampaignsApi);

export const fetchCampaignOptions = createAsyncThunk(
  'campaigns/fetchCampaignOptions',
  searchCampaignsApi,
);

export const fetchScheduledMessages = createAsyncThunk(
  'campaigns/fetchScheduledMessages',
  async ({ jobId, page, itemsPerPage }, { rejectWithValue }) => {
    try {
      return await getScheduledMessages({ jobId, page, itemsPerPage });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchCampaignCandidates = createAsyncThunk(
  'campaigns/fetchCampaignCandidates',
  async ({ jobId, page, itemsPerPage, sort, searchValue }, { rejectWithValue }) => {
    try {
      return await getCampaignCandidates({
        jobId,
        page,
        itemsPerPage,
        sort,
        searchValue,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchCampaignBGEvents = createAsyncThunk(
  'campaigns/backgroundevents',
  async ({ customerId, campaignId, eventStatus }, { rejectWithValue }) => {
    try {
      return await getCampaignBGEvent({ customerId, campaignId, eventStatus });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const addCandidateToCampaign = createAsyncThunk(
  'campaigns/addCandidateToCampaign',
  async ({ campaignId, candidateId }, { rejectWithValue }) => {
    try {
      return await addCandidateToCampaignApi({ campaignId, candidateId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const addBulkCandidateToCampaign = createAsyncThunk(
  'campaigns/addBulkCandidateToCampaign',
  async ({ campaignId, filter }, { rejectWithValue }) => {
    try {
      return await addBulkCandidateToCampaignApi({ campaignId, filter });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const addATSCandidateToCampaign = createAsyncThunk(
  'campaigns/addATSCandidateToCampaign',
  async ({ campaignId, candidateId, customerId }, { rejectWithValue }) => {
    try {
      return await addATSCandidateToCampaignApi({
        campaignId,
        candidateId,
        customerId,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const addCampaign = createAsyncThunk(
  'campaigns/addCampaign',
  async (
    {
      campaignName,
      isReengagement,
      jobCode,
      url,
      autoResponse,
      isAri,
      sequence,
      minDaysLastContacted,
      maxDaysLastContacted,
      tagsData,
      message,
      reEngagementUrl,
      emailFrom,
      timeInISO,
      timeZone,
    },
    { rejectWithValue },
  ) => {
    try {
      return await addCampaignApi({
        campaignName,
        isReengagement,
        code: jobCode,
        url,
        autoResponse,
        isAri,
        sequence,
        minDaysLastContacted,
        maxDaysLastContacted,
        tagsData,
        message,
        reEngagementUrl,
        emailFrom,
        timeInISO,
        timeZone,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getCampaignAriSequences = createAsyncThunk(
  'campaigns/getCampaignAriSequences',
  async (_, { rejectWithValue }) => {
    try {
      return await getSequencesARI();
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchCampaign = createAsyncThunk(
  'campaigns/fetchCampaign',
  async ({ jobId }, { rejectWithValue }) => {
    try {
      return await getCampaign({ jobId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const updateCampaign = createAsyncThunk(
  'campaigns/updateCampaign',
  async (
    {
      campaignName,
      isReengagement,
      jobCode,
      url,
      status,
      autoResponse,
      isAri,
      sequence,
      jobId,
      minDaysLastContacted,
      maxDaysLastContacted,
      tagsData,
      message,
      reEngagementUrl,
      emailFrom,
      timeInISO,
      timeZone,
      isEnabled,
      requestType,
    },
    { rejectWithValue },
  ) => {
    try {
      return await updateCampaignApi({
        campaignName,
        jobId,
        isReengagement,
        code: jobCode,
        url,
        status,
        autoResponse,
        isAri,
        sequence,
        minDaysLastContacted,
        maxDaysLastContacted,
        tagsData,
        message,
        reEngagementUrl,
        emailFrom,
        timeInISO,
        timeZone,
        isEnabled,
        requestType,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
export const addNewCampaign = createAsyncThunk(
  'campaigns/addNewCampaign',
  async ({ name, url, code, autoResponse, sequence }, { rejectWithValue }) => {
    try {
      return await addNewCampaignApi({
        name,
        url,
        code,
        autoResponse,
        sequence,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const removeMultiJobCandidates = createAsyncThunk(
  'campaigns/removeMultipleCandidates',
  async ({ candidateIds, jobId, customerId }, { rejectWithValue }) => {
    try {
      return await removeMultipleSelectedApi({
        candidateIds,
        jobId,
        customerId,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const resetDeleteStatusCandidateCampaign = createAction(
  'thread/resetDeleteStatusCandidateCampaign',
);

export const fetchCandidateJobMax = createAsyncThunk(
  'campaigns/candidateByJob',
  async ({ jobId }, { rejectWithValue }) => {
    try {
      return await fetchCandidateJobMaxApi({ jobId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
